import ConstructionIcon from '@mui/icons-material/Construction';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import { useDocumentTitle } from '@/lib/useDocumentTitle';

interface SectionPlaceholderProps {
  title: string;
  /** One line describing what this section will do, from the wireframes. */
  description?: string;
}

/**
 * Stands in for a section that has not been built yet.
 *
 * Every navigation entry leads to one of these, so the shell contains no dead
 * links while the sections are built over the coming months.
 */
export function SectionPlaceholder({ title, description }: SectionPlaceholderProps) {
  useDocumentTitle(title);

  return (
    <Box>
      <Typography variant="h5" component="h1" sx={{ fontWeight: 600 }}>
        {title}
      </Typography>

      {description ? (
        <Typography color="text.secondary" sx={{ mt: 0.5 }}>
          {description}
        </Typography>
      ) : null}

      <Paper
        variant="outlined"
        sx={{
          mt: 3,
          p: 5,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1,
          bgcolor: 'background.default',
        }}
      >
        <ConstructionIcon color="disabled" fontSize="large" />
        <Typography color="text.secondary">This section is still to be built.</Typography>
      </Paper>
    </Box>
  );
}
